export default __webpack_public_path__ + "static/principle1-bcaa494c6faab58e87249b2bdec6bf4d7061efe3e658433b581ec230115aebb5.png";